/**
 * 组件事件订阅对象
 */
class Subscribe {
  constructor() {
    this.events = {};
  }

  /**
   * 事件订阅
   * @param {*} eventname 监听的事件名称
   * @param {*} event 触发事件内容
   */
  $on(eventname, event) {
    if (!this.events[eventname]) {
      this.events[eventname] = [];
    }
    // console.log('subscribe', eventname);
    this.events[eventname].push(event);
  }

  /**
   * 发送事件
   */
  $emit() {
    let key = Array.prototype.shift.call(arguments);
    //  console.log(key);
    // 返回的值
    let value;

    let fns = this.events[key];
    // console.log(fns.length);
    if (!fns || fns.length == 0) {
      //没有订阅 则返回
      return value;
    }
    //  console.log(fns.length);
    fns.forEach((fn) => {
      // console.log(fn);

      // apply:方法能劫持另外一个对象的方法，继承另外一个对象的属性.
      value = fn.apply(this, arguments);
      // console.log(value);
    });
    return value;
  }

  /**
   * 发送事件
   */
  emit(key) {
    //let key = Array.prototype.shift.call(arguments);
    // console.log(arguments, key);
    let fns = this.events[key];
    if (!fns || fns.length == 0) {
      //没有订阅 则返回
      return false;
    }
    fns.forEach((fn) => {
      // console.log(fn);
      fn.apply(this, arguments);
    });
  }

  /**
   * 清空所有监听事件
   */
  clear() {
    this.events = {};
  }

  /**
   * 获取所有订阅事件ID
   */
  keys() {
    var arr = new Array();
    let i = 0;
    for (let p in this.events) {
      arr[i] = p;
      i++;
    }
    return arr;
  }
}

export default Subscribe;
